type Props = {
  previewContent: string
}

export default function SignaturePreviewContent({ previewContent }: Props) {
  return (
    <div className="signature-preview">
      <div className="signature-preview__content">
        <div className="signature-preview__skeleton">
          <svg xmlns="http://www.w3.org/2000/svg" width="228" height="85" fill="none">
            <path fill="#DFE3E8" d="M184.438 80h6.016v4.8h-6.016V80Z" />
            <path fill="#DFE3E8" d="M175.281 80h10.592v4.8h-10.592V80Z" />
            <path fill="#DFE3E8" d="M170.703 80h6.016v4.8h-6.016V80Z" />
            <path fill="#DFE3E8" d="M161.547 80h10.592v4.8h-10.592V80Z" />
            <path fill="#DFE3E8" d="M156.969 80h6.016v4.8h-6.016V80Z" />
            <path fill="#DFE3E8" d="M147.812 80h10.592v4.8h-10.592V80Z" />
            <path fill="#DFE3E8" d="M138.656 80h10.592v4.8h-10.592V80Z" />
            <path fill="#DFE3E8" d="M129.5 80h10.592v4.8H129.5V80Z" />
            <path fill="#DFE3E8" d="M124.922 80h6.016v4.8h-6.016V80ZM106.172 80h10.592v4.8h-10.592V80Z" />
            <path fill="#DFE3E8" d="M97.016 80h10.592v4.8H97.016V80Z" />
            <path fill="#DFE3E8" d="M87.86 80H98.45v4.8H87.86V80ZM73.688 80h6.016v4.8h-6.016V80Z" />
            <path fill="#DFE3E8" d="M69.11 80h6.015v4.8H69.11V80Z" />
            <path fill="#DFE3E8" d="M59.953 80h10.592v4.8H59.953V80ZM45.781 80h6.016v4.8h-6.016V80Z" />
            <path fill="#DFE3E8" d="M36.625 80h10.592v4.8H36.625V80Z" />
            <path fill="#DFE3E8" d="M27.469 80H38.06v4.8H27.469V80Z" />
            <path fill="#DFE3E8" d="M22.89 80h6.017v4.8H22.89V80Z" />
            <path fill="#DFE3E8" d="M13.734 80h10.592v4.8H13.734V80Z" />
            <path fill="#DFE3E8" d="M4.578 80H15.17v4.8H4.578V80Z" />
            <path fill="#DFE3E8" d="M0 80h6.016v4.8H0V80ZM211.906 60h10.592v4.8h-10.592V60Z" />
            <path fill="#DFE3E8" d="M207.328 60h6.016v4.8h-6.016V60Z" />
            <path fill="#DFE3E8" d="M198.172 60h10.592v4.8h-10.592V60Z" />
            <path fill="#DFE3E8" d="M193.594 60h6.016v4.8h-6.016V60Z" />
            <path fill="#DFE3E8" d="M184.438 60h10.591v4.8h-10.591V60Z" />
            <path fill="#DFE3E8" d="M175.281 60h10.592v4.8h-10.592V60Z" />
            <path fill="#DFE3E8" d="M170.703 60h6.016v4.8h-6.016V60Z" />
            <path fill="#DFE3E8" d="M161.547 60h10.592v4.8h-10.592V60Z" />
            <path fill="#DFE3E8" d="M152.391 60h10.592v4.8h-10.592V60ZM133.641 60h10.592v4.8h-10.592V60Z" />
            <path fill="#DFE3E8" d="M124.484 60h10.592v4.8h-10.592V60Z" />
            <path fill="#DFE3E8" d="M115.328 60h10.592v4.8h-10.592V60Z" />
            <path fill="#DFE3E8" d="M106.172 60h10.592v4.8h-10.592V60Z" />
            <path fill="#DFE3E8" d="M101.594 60h6.016v4.8h-6.016V60ZM87.422 60h6.016v4.8h-6.016V60Z" />
            <path fill="#DFE3E8" d="M82.844 60h6.016v4.8h-6.016V60Z" />
            <path fill="#DFE3E8" d="M73.688 60h10.591v4.8H73.689V60Z" />
            <path fill="#DFE3E8" d="M69.11 60h6.015v4.8H69.11V60Z" />
            <path fill="#DFE3E8" d="M59.953 60h10.592v4.8H59.953V60ZM41.203 60h10.592v4.8H41.203V60Z" />
            <path fill="#DFE3E8" d="M32.047 60h10.592v4.8H32.047V60Z" />
            <path fill="#DFE3E8" d="M22.89 60h10.593v4.8H22.89V60Z" />
            <path fill="#DFE3E8" d="M18.313 60h6.015v4.8h-6.015V60Z" />
            <path fill="#DFE3E8" d="M9.156 60h10.592v4.8H9.156V60Z" />
            <path fill="#DFE3E8" d="M0 60h10.592v4.8H0V60ZM217.359 40h10.592v4.8h-10.592V40Z" />
            <path fill="#DFE3E8" d="M212.781 40h6.016v4.8h-6.016V40ZM198.609 40h6.016v4.8h-6.016V40Z" />
            <path fill="#DFE3E8" d="M189.453 40h10.592v4.8h-10.592V40Z" />
            <path fill="#DFE3E8" d="M184.875 40h6.016v4.8h-6.016V40Z" />
            <path fill="#DFE3E8" d="M175.719 40h10.592v4.8h-10.592V40Z" />
            <path fill="#DFE3E8" d="M166.562 40h10.592v4.8h-10.592V40ZM152.391 40h6.016v4.8h-6.016V40Z" />
            <path fill="#DFE3E8" d="M143.234 40h10.592v4.8h-10.592V40Z" />
            <path fill="#DFE3E8" d="M134.078 40h10.592v4.8h-10.592V40Z" />
            <path fill="#DFE3E8" d="M129.5 40h6.016v4.8H129.5V40Z" />
            <path fill="#DFE3E8" d="M120.344 40h10.592v4.8h-10.592V40Z" />
            <path fill="#DFE3E8" d="M115.766 40h6.016v4.8h-6.016V40Z" />
            <path fill="#DFE3E8" d="M106.609 40h10.592v4.8h-10.592V40Z" />
            <path fill="#DFE3E8" d="M97.453 40h10.592v4.8H97.453V40ZM69.11 40H79.7v4.8H69.11V40Z" />
            <path fill="#DFE3E8" d="M64.531 40h6.016v4.8h-6.016V40ZM45.781 40h10.592v4.8H45.781V40Z" />
            <path fill="#DFE3E8" d="M36.625 40h10.592v4.8H36.625V40Z" />
            <path fill="#DFE3E8" d="M27.469 40H38.06v4.8H27.469V40Z" />
            <path fill="#DFE3E8" d="M18.313 40h10.591v4.8H18.313V40Z" />
            <path fill="#DFE3E8" d="M13.734 40h6.016v4.8h-6.016V40Z" />
            <path fill="#DFE3E8" d="M9.156 40h6.016v4.8H9.156V40Z" />
            <path fill="#DFE3E8" d="M0 40h10.592v4.8H0V40ZM206.891 20h6.016v4.8h-6.016V20Z" />
            <path fill="#DFE3E8" d="M202.312 20h6.017v4.8h-6.017V20Z" />
            <path fill="#DFE3E8" d="M197.734 20h6.016v4.8h-6.016V20Z" />
            <path fill="#DFE3E8" d="M193.156 20h6.016v4.8h-6.016V20Z" />
            <path fill="#DFE3E8" d="M184 20h10.592v4.8H184V20ZM165.25 20h10.592v4.8H165.25V20Z" />
            <path fill="#DFE3E8" d="M156.094 20h10.592v4.8h-10.592V20Z" />
            <path fill="#DFE3E8" d="M151.516 20h6.016v4.8h-6.016V20Z" />
            <path fill="#DFE3E8" d="M142.359 20h10.592v4.8h-10.592V20Z" />
            <path fill="#DFE3E8" d="M133.203 20h10.592v4.8h-10.592V20Z" />
            <path fill="#DFE3E8" d="M128.625 20h6.016v4.8h-6.016V20Z" />
            <path fill="#DFE3E8" d="M119.469 20h10.592v4.8h-10.592V20Z" />
            <path fill="#DFE3E8" d="M114.891 20h6.016v4.8h-6.016V20Z" />
            <path fill="#DFE3E8" d="M105.734 20h10.592v4.8h-10.592V20Z" />
            <path fill="#DFE3E8" d="M96.578 20h10.592v4.8H96.578V20ZM82.406 20h6.016v4.8h-6.016V20Z" />
            <path fill="#DFE3E8" d="M73.25 20h10.592v4.8H73.25V20Z" />
            <path fill="#DFE3E8" d="M68.672 20h6.016v4.8h-6.016V20Z" />
            <path fill="#DFE3E8" d="M59.516 20h10.592v4.8H59.516V20Z" />
            <path fill="#DFE3E8" d="M54.938 20h6.015v4.8h-6.016V20Z" />
            <path fill="#DFE3E8" d="M45.781 20h10.592v4.8H45.781V20Z" />
            <path fill="#DFE3E8" d="M36.625 20h10.592v4.8H36.625V20Z" />
            <path fill="#DFE3E8" d="M27.469 20H38.06v4.8H27.469V20Z" />
            <path fill="#DFE3E8" d="M18.313 20h10.591v4.8H18.313V20Z" />
            <path fill="#DFE3E8" d="M9.156 20h10.592v4.8H9.156V20Z" />
            <path fill="#DFE3E8" d="M0 20h10.592v4.8H0V20ZM203.188 0h6.016v4.8h-6.016V0Z" />
            <path fill="#DFE3E8" d="M198.609 0h6.016v4.8h-6.016V0Z" />
            <path fill="#DFE3E8" d="M189.453 0h10.592v4.8h-10.592V0Z" />
            <path fill="#DFE3E8" d="M180.297 0h10.592v4.8h-10.592V0Z" />
            <path fill="#DFE3E8" d="M171.141 0h10.592v4.8h-10.592V0ZM156.969 0h6.016v4.8h-6.016V0Z" />
            <path fill="#DFE3E8" d="M152.391 0h6.016v4.8h-6.016V0Z" />
            <path fill="#DFE3E8" d="M143.234 0h10.592v4.8h-10.592V0ZM129.062 0h6.017v4.8h-6.017V0Z" />
            <path fill="#DFE3E8" d="M119.906 0h10.592v4.8h-10.592V0Z" />
            <path fill="#DFE3E8" d="M115.328 0h6.016v4.8h-6.016V0Z" />
            <path fill="#DFE3E8" d="M106.172 0h10.592v4.8h-10.592V0Z" />
            <path fill="#DFE3E8" d="M97.016 0h10.592v4.8H97.016V0ZM78.266 0h10.592v4.8H78.266V0Z" />
            <path fill="#DFE3E8" d="M69.11 0H79.7v4.8H69.11V0Z" />
            <path fill="#DFE3E8" d="M59.953 0h10.592v4.8H59.953V0Z" />
            <path fill="#DFE3E8" d="M50.797 0h10.592v4.8H50.797V0Z" />
            <path fill="#DFE3E8" d="M46.219 0h6.016v4.8h-6.016V0ZM27.469 0H38.06v4.8H27.469V0Z" />
            <path fill="#DFE3E8" d="M18.313 0h10.591v4.8H18.313V0Z" />
            <path fill="#DFE3E8" d="M13.734 0h6.016v4.8h-6.016V0Z" />
            <path fill="#DFE3E8" d="M4.578 0H15.17v4.8H4.578V0Z" />
            <path fill="#DFE3E8" d="M0 0h6.016v4.8H0V0Z" />
          </svg>
        </div>

        {previewContent ? (
          <div className="signature-preview__signature" dangerouslySetInnerHTML={{ __html: previewContent }} />
        ) : (
          <div className="signature-preview__signature signature-preview__signature--empty">
            {i18n.t("js.email_accounts.accounts.no_signature_preview")}
          </div>
        )}
      </div>
    </div>
  )
}
